import { useState, useEffect } from 'react';

export const Countdown = ({ 
  targetDate,
  daysLabel = 'DAYS',
  hoursLabel = 'HOURS',
  minutesLabel = 'MINUTES',
  secondsLabel = 'SECONDS'
}) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = new Date(targetDate) - new Date();
      
      if (difference > 0) {
        return {
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60)
        };
      }
      
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    };

    const timer = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    setTimeLeft(calculateTimeLeft());

    return () => clearInterval(timer);
  }, [targetDate]);

  const timeUnits = [
    { value: timeLeft.days, label: daysLabel },
    { value: timeLeft.hours, label: hoursLabel },
    { value: timeLeft.minutes, label: minutesLabel },
    { value: timeLeft.seconds, label: secondsLabel }
  ];

  return (
    <div className="grid grid-cols-4 gap-3">
      {timeUnits.map((unit, index) => (
        <div 
          key={unit.label}
          className="text-center"
        >
          <div className="text-3xl font-serif font-bold blue-text mb-1">
            {String(unit.value).padStart(2, '0')}
          </div>
          <div className="text-xs font-sans tracking-widest text-muted-foreground">
            {unit.label}
          </div>
        </div>
      ))}
    </div>
  );
};
